import { useTranslation } from 'react-i18next';

import { itemStyle, itemSubtitleStyle, itemTitleStyle, summaryStyle } from './Chart.css';

export type Props = {
  amount: number;
  label: string;
  value: string;
};

export const ChartSummary = ({ amount, label, value }: Props) => {
  const { t } = useTranslation(['dashboard']);

  return (
    <div className={summaryStyle}>
      <p className={itemTitleStyle}>{label}</p>

      <div className={itemStyle}>
        <p className={itemSubtitleStyle}>{t('dashboard:charts.summary.amountInvoices')}</p>

        <p className={itemTitleStyle}>{amount}</p>
      </div>

      <div className={itemStyle}>
        <p className={itemSubtitleStyle}>{t('dashboard:charts.summary.value')}</p>

        <p className={itemTitleStyle}>{value}</p>
      </div>
    </div>
  );
};
